var $ = require('jquery');
'use strict';

var PLUGIN_NAME = 'simpleScrollTo';

var	DEFAULTS = {
	selector: '',
	type: 'href',
	offsetY: -10
};

var SimpleScrollTo = function (selector, options) {
	this.$t = $(selector);
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;
	this.initialise_();
};

SimpleScrollTo.prototype.initialise_ = function() {
	if (this.options.selector && this.options.selector != '') {
		this.bindEvents_();
	}
};

/**
 * bind listener on actual element to process child elements
 * @private
 */
SimpleScrollTo.prototype.bindEvents_ = function() {
	var self_ = this;
	this.$t.on('click', this.options.selector, function(event) {
		event.preventDefault();
		var target = self_.getTargetElement_(event.currentTarget);
		self_.performScroll_($(target), $(event.currentTarget).data('offsetY'));
	});
};

/**
 * return target element by type
 * @param el
 * @returns {string}
 * @private
 */
SimpleScrollTo.prototype.getTargetElement_ = function(el) {
	var result = '';
	switch(this.options.type) {
		case 'href':
		default:
			result = $(el).attr('href');
			break;
	}
	return result;
};

SimpleScrollTo.prototype.performScroll_ = function($el, offsetY) {
	$('html, body').animate({ scrollTop: $el.offset().top + (!isNaN(parseInt(offsetY)) ? -1*parseInt(offsetY) : this.options.offsetY) }, 200);
};

/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new SimpleScrollTo(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.simple-scroll-to.js